import { z } from "zod";
//#region src/schemas/reference.ts
/**
* Zod schemas for the reference-data blobs. Admin-api writes these, public-api and public-ui read
* them — a shape mismatch on either side is the silent-drift failure mode this schema exists to
* prevent. Leaves are strict where the reader actually depends on the shape; ancillary/unused
* fields stay permissive so the contract doesn't lock in details that may still evolve.
*/
const stateSchema = z.object({
	STA_Code: z.string(),
	STA_Name: z.string()
});
const schoolSchema = z.object({
	SCH_School_PK: z.number().int().optional(),
	SCH_Name: z.string(),
	SCH_DisplayName: z.string().nullish(),
	SCH_Link: z.string().nullish(),
	STA_Code: z.string().nullish(),
	SCH_City: z.string().nullish(),
	SCH_Type: z.string()
});
const policyFilesYearSchema = z.object({
	year: z.number().int(),
	volPlanEndDate: z.string().optional(),
	policyEndDate: z.string().optional(),
	schoolLink: z.string().nullish(),
	planLinks: z.array(z.string()),
	brochure: z.array(z.string()),
	spanish: z.array(z.string()),
	athletic: z.array(z.string()),
	needlestick: z.array(z.string()),
	summary: z.array(z.string()),
	uil: z.array(z.string()),
	pid: z.array(z.string()),
	certificates: z.array(z.string()),
	notice: z.array(z.string())
});
const policyFilesSchema = z.object({
	current: policyFilesYearSchema,
	previous: policyFilesYearSchema
});
const adminFilesSchema = z.object({
	cat: z.array(z.string()),
	gsp: z.array(z.string()),
	vol: z.array(z.string()),
	sports: z.array(z.string()).default([]),
	group: z.array(z.string()).default([]),
	accident: z.array(z.string()).default([]),
	guaranty: z.array(z.string())
});
/**
* Shape of `reference-data/reference.json`. Writer: admin-api timer. Readers: public-api
* admin-login handler + public-ui reference store.
*/
const referenceBundleSchema = z.object({
	generatedAt: z.string(),
	year: z.number().int(),
	states: z.array(stateSchema),
	schools: z.array(schoolSchema),
	schoolFiles: z.record(z.string(), policyFilesSchema).optional(),
	adminFiles: z.record(z.string(), adminFilesSchema).optional()
});
/**
* Shape of `reference-data/enrollment/{pk}.json`. Leaves stay permissive — the reader passes them
* straight to rendering logic, and the critical invariant here is "the top-level keys exist with
* the right kind". Tighten individual leaves only when a consumer needs stronger guarantees.
*/
const enrollmentBundleSchema = z.object({
	generatedAt: z.string(),
	year: z.object({}).passthrough(),
	school: z.object({}).passthrough(),
	schools: z.array(z.unknown()),
	policies: z.array(z.unknown()),
	rows: z.array(z.unknown()),
	columns: z.array(z.unknown()),
	rates: z.array(z.unknown()),
	optionalCoverage: z.array(z.unknown())
});
//#endregion
export { enrollmentBundleSchema, referenceBundleSchema };

//# sourceMappingURL=reference.mjs.map